import { Card, Typography, Button, Space, Descriptions } from 'antd'
import { LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { useAuthStore } from '~/app/services/auth'
import { useSelectedWorkspaceStore } from '~/app/services/workspace'
import { useUserStore } from '~/app/services/user'
import { useNavigate } from 'react-router-dom'
import { AUTH_PATH } from '~/app/lib/paths'

const { Title, Text } = Typography

export default function DashboardPage() {
  const navigate = useNavigate()
  const { selectedTenant, clearAuth } = useAuthStore()
  const { selectedWorkspace } = useSelectedWorkspaceStore()
  const { logout } = useUserStore()

  const handleLogout = () => {
    logout()
    clearAuth()
    navigate(AUTH_PATH.SIGN_IN)
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <Card>
          <div className="flex justify-between items-center mb-6">
            <Title level={2}>
              <UserOutlined /> Dashboard
            </Title>
            <Button icon={<LogoutOutlined />} onClick={handleLogout}>
              Logout
            </Button>
          </div>

          <Space direction="vertical" size="large" className="w-full">
            <Card type="inner" title="Authentication Status" className="bg-green-50">
              <Text strong className="text-green-600">
                ✓ Successfully Authenticated
              </Text>
            </Card>

            <Descriptions title="Current Session" bordered column={1}>
              <Descriptions.Item label="Tenant">
                <Text strong>{selectedTenant?.name || 'Not selected'}</Text>
                <br />
                <Text type="secondary">{selectedTenant?.slug}</Text>
              </Descriptions.Item>

              <Descriptions.Item label="Workspace">
                <Text strong>{selectedWorkspace?.name || 'Not selected'}</Text>
                <br />
                <Text type="secondary">
                  {selectedWorkspace?.is_synced ? '✓ Synced with CXGenie' : 'Not synced'}
                </Text>
              </Descriptions.Item>

              <Descriptions.Item label="Workspace ID">
                <Text code>{selectedWorkspace?.id || 'N/A'}</Text>
              </Descriptions.Item>

              <Descriptions.Item label="CXGenie Workspace ID">
                <Text code>{selectedWorkspace?.cxg_workspace_id || 'N/A'}</Text>
              </Descriptions.Item>
            </Descriptions>

            <Card type="inner" title="Next Steps">
              <Space direction="vertical">
                <Text>• The authentication flow is working correctly</Text>
                <Text>• You can now build additional pages and features</Text>
                <Text>• All API services are ready to use</Text>
                <Text>• State is persisted across page reloads</Text>
              </Space>
            </Card>
          </Space>
        </Card>
      </div>
    </div>
  )
}
